import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ExcelService } from '../../services/export-excel/export-excel.service';
import { DialogService } from '../../services/dialog-service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { PanelListService } from '../../services/panel-list.service';
import { FunnelReportService } from '../../services/funnel-report.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  public tableData: any = [];
  public isTable: string;
  public url: string;
  public tableIndex: any;
  public tableFormate: any;
  public isData: boolean = false;
  public confirmMsg: string = 'Are you sure you want to reject this duplicate entry? This action cannot be reversed.';
  public id: number;
  public mode: number;
  public studyId: string;
  public updated: boolean = false;
  public isLoading: boolean = false;
  public isFilter: boolean = false;
  public duplicateDetails: any;
  public groups = [];
  public terminatedList = [];
  public headers = [];
  public listImg: any;
  public groupBy: string;
  public export = '';

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: boolean,
    private dialogService: DialogService,
    private excelService: ExcelService,
    private router: Router,
    private logerror: LoginService,
    public sanitization: DomSanitizer,
    private notifier: NotifierService,
    public funnelService: FunnelReportService,
    private panelService: PanelListService
  ) {
    this.tableData = [];
    this.tableData = this.dialogService.tableData;
    this.isTable = this.dialogService.isData;
    this.url = this.dialogService.imgUrl;
    this.tableIndex = this.dialogService.tableIndex;
    this.tableFormate = this.dialogService.tableFormate;
    this.id = this.dialogService.id;
    this.confirmMsg = this.dialogService.confirmMsg;
    this.mode = this.dialogService.mode;
    this.studyId = this.dialogService.studyId;
  }

  onNoClick(): void {
    this.dialogRef.close({ type: 'close' });
  }

  ngOnInit() {
    if (this.isTable == 'img') {
      this.getDupilicateData();
    }
    else if (this.isTable == 'listImg') {
      this.getImages();
    }
    if (this.isTable == 'terminated') {
      this.getTerminatedData();
    }
    this.export = '';
  }

  exportToExcel() {
    let exportXlsx: string = '[';
    for (let j = 0; j < this.tableData['tableData'].length; j++) {
      exportXlsx += '{ "S.NO":"' + (j + 1) + '" ,';
      for (let i = 0; i < this.tableData['tableHead'].length; i++) {
        let value: string = this.tableData['tableData'][j][i];
        if (this.tableData['tableData'][j][i].indexOf('src') > 0) {
          if (value.indexOf('>View') !== -1 || value.indexOf('>Duplicate') !== -1) {
            value = value.split('"')[9];
          } else {
            value = this.tableData['tableData'][j][i].split('"')[15];
          }
        }
        exportXlsx += '"' + this.tableData['tableHead'][i] + '":"' + value + '"';
        if (i === this.tableData['tableHead'].length - 1) {
          exportXlsx += '';
        } else {
          exportXlsx += ',';
        }
      }
      exportXlsx += '}';
      if (j === this.tableData['tableData'].length - 1) {
        exportXlsx += '';
      } else {
        exportXlsx += ',';
      }
    }
    exportXlsx += ']';
    this.excelService.exportAsExcelFile(JSON.parse(exportXlsx), 'panel-list-data');
  }

  printTable() {
    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.write(this.tableFormate);
    popupWin.focus();
    popupWin.print();
    popupWin.close();
  }

  checkData(data: string): boolean {
    return data.indexOf('<img') === -1 ? false : true;
  }

  getUrl(data: string): string {
    if (data.indexOf('>Duplicate') !== -1 || data.indexOf('>View') !== -1) {
      return data.split('"')[9];
    }
    return data.split('"')[15];
  }

  updateRespondent() {
    this.updated = false;
    this.dialogRef.close({ type: 'update' });
    this.panelService.updateRespondent(this.id, this.mode, this.studyId).subscribe(
      (data) => {

        this.updated = true;
      },
      (error) => {
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
      });
  }

  getImages() {
    this.panelService.getImages(this.data['userId']).subscribe(
      (data) => {
        this.listImg = data.result;
      },
      (error) => {
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
      });
  }

  submitDuplicte(value: number) {
    this.dialogRef.close({ type: 'img', duplicate: value });
  }

  getDupilicateData() {
    this.isLoading = true;
    this.panelService.getDuplicate({ dup_id: this.data['dupId'], image_status: this.data['imageStatus'] }).subscribe(
      (result) => {
        this.duplicateDetails = result.data;
        this.isLoading = false;
        if (result.error) {
          this.dialogRef.close({ type: 'error', error: result.error });
        }
      },
      (error) => {
        if (error.status === 403) {
          this.router.navigate(['home/access-denied']);
        }
        this.isLoading = false;
        this.dialogRef.close({ type: 'error', error: 'Something went wrong' });
      });
  }

  getTerminatedData() {
    this.isLoading = true;
    let data = {
      studyId: this.studyId,
      report_type: 'tqf',
      entity_id: this.data['row']['id'],
      type: this.data['row']['type'],
      filter: JSON.stringify(this.data['filter']),
      group: this.groupBy
    };
    if (this.export == 'csv') {
      data['export'] = this.export;
    }
    this.funnelService.getFunnelReport(data).subscribe((result) => {
      if (result['status'] == 1) {
        if (data['export'] == 'csv') {
          this.notifier.notify('success', "Email will be sent to you shortly");
        } else {
          this.terminatedList = result['report'];
          this.headers = result['header'];
          this.groups = result['group'];
        }
        if (this.terminatedList.length > 0) {
          this.isData = true;
        }
      }else{
        this.isLoading = false;
        this.export = '';
        this.notifier.notify('error', "Something went wrong");
      }
      this.export = '';
      this.isLoading = false;
    },
      error => {
        this.isLoading = false;
        this.export = '';
        this.notifier.notify('error', "Something went wrong");
      });
  }

  zoomOutData() {
    if(this.isData){
      const popupWin = window.open('', '_blank');
      popupWin.document.write(this.getTerminatedTable());
    }
  }

  onBlurFilter() {
    setTimeout(() => {
      this.isFilter = false;
    }, 400);
  }

  switchGroup(group: string) {
    this.isFilter = !this.isFilter;
    if (group != 'default') {
      this.groupBy = group;
    } else {
      this.groupBy = undefined;
    }
    this.getTerminatedData();
  }
  
  switchFilter() {
    this.isFilter = !this.isFilter;
  }

  removeTags(question: any): any {
    if (typeof question == 'string') {
      return (((question.replace(/<[^>]*>/g, '')).replace('{{', ' ')).replace('}}', ' ')).replace(/_/g, ' ');
    }
    return question;
  }

  styleTrust(data: any): any {
    let count = 0;
    data.forEach((key) => {
      count++;
    });
    return this.sanitization.bypassSecurityTrustStyle('repeat(' + (count) + ', 1fr)');
  }

  exportCSV() {
    // this.export = 'csv';
    if(this.terminatedList.length > 0){
      this.excelService.exportAsExcelFile(this.terminatedList, 'terminated-report');
    }else{
      this.notifier.notify('error', 'No data to export csv');
    }
  }

  
  getRowColor(row: any): string {
    let color: string = '';
    if(row){
      const count = parseInt(row['count']);
      if(count > 0){
        let isGreater = this.data['row']['terminated'] / 10;
        if (count >= isGreater) {
          color = '#FFAFAF';
        }
      }
    }
    return color;
  }

  getRowBoderColor(row: any): string {
    let color: string = '';
    if(row){
      const count = parseInt(row['count']);
      if(count > 0){
        let isGreater = this.data['row']['terminated'] / 10;
        if (count >= isGreater) {
          color = '1px solid #fe7a7a';
        }
      }
    }
    return color;
  }
  
  getTerminatedTable(): string {
    const style = `*{
      font-family:'Open Sans', sans-serif;
    }
    .terminated-body{height:100%;}
    .terminated-body>.terminated-head{    
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
        display: grid;
        grid-column-gap: 1%;
        grid-template-columns: repeat(7, 1fr);
        text-transform: capitalize;
        padding: 10px 0;
        border-bottom: 1px solid #efefef;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.19px;
        text-transform: uppercase;
        color: #4a4a4a;
    }
    .terminated-body>.terminated-head>li{
        display: flex;
        align-items: center;
    }
    .terminated-body>.terminated-data{
        list-style: none;height: 94%;
        margin: 0;
        padding: 0;
        overflow: auto;
    }
    .terminated-body>.terminated-data>li{
        width: 100%;
        display: grid;
        grid-column-gap: 1%;
        grid-template-columns: repeat(7, 1fr);
        padding: 8px 0;
        font-size: 12px;
        letter-spacing: 0.19px;
        color: #192f6a;
        text-transform: capitalize;
    }
    .terminated-body>.terminated-data>li:nth-child(even){
        background: #f6f6f6;
    }`;
    let data = `<html><head><title>Terminated Data</title><style>`+style+`</style></head><body><div class="terminated-body"><ul class="terminated-head" style.grid-template-columns:`+ this.styleTrust(this.headers) + `">`;
    this.headers.forEach(head => {
      data = data + (`<li>` + this.removeTags(head) + `</li>`);
    });      
    data = data + (`</ul><ul class="terminated-data">`);
    this.terminatedList.forEach(row => {
      data = data + ( `<li style="grid-template-columns: ` + this.styleTrust(this.headers) + `">`);
      let cellData = '';
        this.headers.forEach(rowData => {
          cellData = cellData + (`<div>` + (this.removeTags(row[rowData]) || '-') + `<span style="color: red;"> ` + (row['status'] == '2' && rowData == 'response_id'? ' *':'') + `</span></div>`);
        });
        cellData = cellData + ( `</li>`);
      data = data + cellData;
    });
    data = data +  `</ul></div></body></html>`;
    return data;
  }
}
